import { Injectable } from '@angular/core';
import { RequestStatusService } from '@df/api/request/request-status.service';
import { Basket } from '@df/basket/basket.interfaces';
import { Giftcards } from '@df/module-giftcards/giftcards';
import { TimeoutService } from '@df/ng/timeout.service';
import { Nexus } from '@tomandco/nexus-api-types';
import { Subject } from 'rxjs';

export const TOTALS_REQUESTS = [
    Nexus.Api.Basket.Add.path,
    Nexus.Api.Basket.Remove.path,
    Nexus.Api.Basket.Qty.path,
    Nexus.Api.Basket.ChangeRequest.path,
    Nexus.Api.Coupon.Add.path,
    Nexus.Api.Coupon.Remove.path,
    Basket.ENDPOINTS.checkoutRemove,
    Giftcards.Endpoints.Add,
    Giftcards.Endpoints.Remove,
    Giftcards.Endpoints.CheckoutAdd,
    Giftcards.Endpoints.CheckoutRemove
];

@Injectable({ providedIn: 'root' })
export class BasketTotalsUpdatingService {
    subject = new Subject<boolean>();

    totalsUpdating = false;

    private onRequestChangeDebounced = this.timeoutService.debounce(() => this.onRequestChange(), 100);

    constructor(private requestStatusService: RequestStatusService, private timeoutService: TimeoutService) {
        this.requestStatusService.subject.subscribe(() => this.onRequestChangeDebounced());
        this.onRequestChange();
    }

    private onRequestChange(): void {
        const totalsUpdating = !!this.requestStatusService.getRequests().find(request => {
            const path = request.path;
            return path && TOTALS_REQUESTS.includes(path);
        });
        if (this.totalsUpdating !== totalsUpdating) {
            this.totalsUpdating = totalsUpdating;
            this.subject.next(totalsUpdating);
        }
    }
}
